// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__WwpDL","title":"ClientReferral_title__2Tohr","itemText":"ClientReferral_itemText__1IW2L"};